import React from 'react';

import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiListItemText from '@material-ui/core/ListItemText';

export default React.forwardRef(function MenuTypography(props, ref)
{
  const {
    label,
    optionLabel,
    icon,
    ...rest
  } = props;

  return (
    <MuiMenuItem ref={ref} {...rest}>
      <MuiListItemIcon>
        {icon}
      </MuiListItemIcon>
      <MuiListItemText
        primary={label}
        secondary={optionLabel}>
      </MuiListItemText>                
    </MuiMenuItem>
  );
});